exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".slack-source-manager {\n  margin-bottom: 20px; }\n  .slack-source-manager .source-info {\n    color: white; }\n    .slack-source-manager .source-info .slack-logo {\n      background-image: url(" + require("./assets/circle_logo_slack.svg") + ");\n      width: 35px;\n      height: 35px;\n      background-repeat: no-repeat;\n      margin: 10px; }\n  .slack-source-manager .slack-content {\n    padding: 0 20px; }\n    .slack-source-manager .slack-content .info {\n      color: #673bb7;\n      margin: 20px 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/slack_source_manager/slack_source_manager.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/slack_source_manager/slack_source_manager.scss
// module chunks = index